const DIMS_TEMPORALES = ["dia", "semana", "mes", "trimestre", "anio"];

// Filas en orden de fecha para el gráfico de línea, o null si el reporte no da
// una línea: con otra dimensión hay varios valores por fecha. Copia porque la
// tabla sigue en el orden pedido al backend. Las etiquetas (2026-07, 2026-S01,
// 2026-T3) ordenan bien como texto.
export function filasParaLinea(filas, dimensiones) {
  if (dimensiones.length !== 1 || !DIMS_TEMPORALES.includes(dimensiones[0])) return null;
  const dim = dimensiones[0];
  return [...filas].sort((a, b) => (a[dim] < b[dim] ? -1 : a[dim] > b[dim] ? 1 : 0));
}
